<template>
  <v-expansion-panel class="mb-4">
    <v-expansion-panel-header>
      <span class="text-uppercase">
        {{ sectionName }}
        <v-icon v-if="isDone" small class="ml-2" color="success">done</v-icon>
      </span>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <slot></slot>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    isDone: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sectionName() {
      return this.$t(`section.${this.name}`);
    },
  },
};
</script>
